var chunkMapping = {
	"0": [
		4607
	],
	"3": [
		4004,
		4539
	],
	"79": [
		5045
	],
	"164": [
		5132
	],
	"165": [
		5133
	],
	"168": [
		5136
	],
	"169": [
		5137
	],
	"170": [
		5138
	],
	"171": [
		5139
	],
	"172": [
		5140
	],
	"173": [
		5141
	],
	"174": [
		5142
	],
	"175": [
		5143
	],
	"176": [
		5144
	],
	"177": [
		5145
	],
	"178": [
		5146
	],
	"179": [
		5147
	],
	"180": [
		5148
	],
	"181": [
		5149
	],
	"182": [
		5150
	],
	"183": [
		5151
	],
	"184": [
		5152
	],
	"185": [
		5153
	],
	"186": [
		5154
	],
	"187": [
		5155
	]
};
var idToExternalAndNameMapping = {
	"4004": [
		"default",
		"./nuorder-components",
		3686
	],
	"4539": [
		"default",
		"./helios-components",
		3686
	],
	"4607": [
		"default",
		"./Containers",
		3596
	],
	"5045": [
		"default",
		"./OrderlessInvoices",
		3596
	],
	"5132": [
		"default",
		"./AsyncEventTracker",
		3596
	],
	"5133": [
		"default",
		"./HostWrapper",
		3596
	],
	"5136": [
		"default",
		"./CheckoutV3",
		3596
	],
	"5137": [
		"default",
		"./CheckoutConfirmation",
		3596
	],
	"5138": [
		"default",
		"./ContactCreditCards",
		3596
	],
	"5139": [
		"default",
		"./AuditDialog",
		3596
	],
	"5140": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3596
	],
	"5141": [
		"default",
		"./InvoiceDialog",
		3596
	],
	"5142": [
		"default",
		"./PaymentDueModal",
		3596
	],
	"5143": [
		"default",
		"./PaymentModal",
		3596
	],
	"5144": [
		"default",
		"./PaymentHistory",
		3596
	],
	"5145": [
		"default",
		"./PaymentConfigurations",
		3596
	],
	"5146": [
		"default",
		"./PaymentPreferences",
		3596
	],
	"5147": [
		"default",
		"./ManagePaymentProcessing",
		3596
	],
	"5148": [
		"default",
		"./MobilePaymentsWrapper",
		3596
	],
	"5149": [
		"default",
		"./PayPage",
		3596
	],
	"5150": [
		"default",
		"./Challenge",
		3596
	],
	"5151": [
		"default",
		"./ManagePaymentMethods",
		3596
	],
	"5152": [
		"default",
		"./LightspeedReports",
		3596
	],
	"5153": [
		"default",
		"./ActivateLightspeedPayments",
		3596
	],
	"5154": [
		"default",
		"./MarketingLandingPage",
		3596
	],
	"5155": [
		"default",
		"./ShippingPromotionsListContainer",
		3596
	]
};
var idToRemoteMap = {
	"4004": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3686
		}
	],
	"4539": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3686
		}
	],
	"4607": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5045": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5154": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	],
	"5155": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3596
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}